import { AdminService, AdminUsersResponseDto } from 'app/API';
import type { TCall } from './types/TCall';

const baseExportParams = {
  pageNo: '1',
  orderBy: 'createdAt',
  orderType: 'desc',
  search: '',
};

export const fetchAllAdminUsersForExport = async (call: TCall): Promise<AdminUsersResponseDto> => {
  const countResponse = await call(() =>
    AdminService.getAdmins({
      ...baseExportParams,
      pageSize: '1',
    }),
  );

  if (countResponse.count === 0) {
    return { count: 0, data: [] };
  }

  return call(() =>
    AdminService.getAdmins({
      ...baseExportParams,
      pageSize: countResponse.count.toString(),
    }),
  );
};
